export const detailedPlanningMessages = {
	SCREEN_TITLES: {
		CONSENSUS: 'Plano Irrestrito',
		COMMERCIAL_COLLABORATION: 'Plano da Colaboração Comercial',
		MARKETING_COLLABORATION: 'Plano da Colaboração Marketing',
		PLANNING_COLLABORATION: 'Plano da Colaboração Planejamento',
	},
	MSG_NO_PERMISSION:
		'Você não possui permissão de visualização desta tela. Por favor, contate seu administrador.',
	MSG_READ_ONLY_NO_EDIT_PERMISSION:
		'Sua conta permite visualizar esta área, mas não editar os valores. Peça ao administrador para habilitar a permissão. Se as permissões foram alteradas agora há pouco, faça logout e login novamente para atualizar a sessão.',
	MSG_READ_ONLY_DEPRECATED_CYCLE:
		'Este ciclo já foi encerrado. A digitação e o salvamento ficam bloqueados.',
};
